<template>
  <div class="card is-min-width-700">
    <header class="bandeau-modal card-header">
    </header>
    <div class="pdl-20px pdr-20px">
      <div class="center">
        <div class="columns is-gapless">
          <div class="column mgt-20px">
            <h1 class="title is-size-3">
              {{ $t('gestionAffectation.popUpAffectationListeAffichage.title') }}
            </h1>
          </div>
        </div>
      </div>
      <div class="card-content pdl-0 pdr-0">
        <div class="columns is-multiline">
          <div class="column is-12 mgb-0">
            <b-field
              :label="$t('gestionAffectation.popUpAffectationListeAffichage.listeAffichage')"
              class="obligatoire">
              <b-autocomplete
                :value="nomListeAffichage"
                :data="listeAffichage"
                field="libelle"
                @select="selectListeAffichage"
                @input="getListeAffichage"
                :loading="isFetching">
                <template slot-scope="props">
                  {{ props.option.libelle }}
                </template>
                <template slot="empty">
                  <div v-if="!isFetching">
                    {{$t('general.autocomplete.noRslt')}}
                  </div>
                </template>
              </b-autocomplete>
            </b-field>
          </div>
        </div>
        <footer>
          <b-field>
            <div class="is-pulled-left boutonAction">
              <a class="button" @click="$parent.close()">
                {{ $t('general.button.cancel')}}
              </a>
            </div>
            <div class="is-pulled-left boutonAction">
              <a class="button is-addOrEdit" @click="$emit('listeAffichage', listeAffichageId)">
                {{ $t('general.button.sauvegarder') }}
              </a>
            </div>
          </b-field>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import debounce from 'lodash/debounce';
import { getAll } from '@/api/logistique/tourneeModele/index';
import messageErreur from '@/services/general/messageErreur';

const Societe = createNamespacedHelpers('societe');

export default {
  name: 'p_affecterListeAffichage',
  data() {
    return {
      listeAffichageId: null,
      listeAffichage: [],
      isFetching: false,
      nomListeAffichage: null,
    };
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
  },
  methods: {
    getListeAffichage: debounce(async function listeAffichageData(text) {
      if (text === this.nomListeAffichage) return;
      try {
        this.nomListeAffichage = text;
        this.isFetching = true;
        this.listeAffichageId = null;
        const result = (await getAll({
          query: {
            auto: text,
            societeId: this.societeActiveId,
          },
        })).data.result.items;
        this.listeAffichage = result.filter((liste) => {
          return this.listeAffichageId !== liste.id;
        });
      } catch (e) {
        messageErreur(this.$i18n);
        throw e;
      } finally {
        this.isFetching = false;
      }
    }, 500),
    selectListeAffichage(data) {
      this.listeAffichageId = data?.id;
      this.nomListeAffichage = data?.libelle;
    },
  },
};
</script>

<style scoped>

</style>
